import api from './api';

export interface VoiceMessage {
  role: 'user' | 'assistant';
  content: string;
  ts: string;
  medium: string;
  tokens?: number;
}

export interface VoiceSession {
  id: string;
  started_at: string;
  last_active: string;
  summary?: string;
  messages: VoiceMessage[];
  status: 'active' | 'closed';
}

export interface Project {
  id: string;
  name: string;
  description?: string;
  project_features?: string;
  head_of_project?: string;
  sub_projects: string[];
  kb_id?: string;  // Legacy - deprecated
  kb_ids?: string[];  // Multi-KB support
  voice_sessions?: VoiceSession[];
  created_date: string;
  last_updated: string;
}

export interface ProjectCreate {
  name: string;
  description?: string;
  head_of_project?: string;
}

export const projectService = {
  async getProjects(): Promise<Project[]> {
    const response = await api.get<Project[]>('/projects/');
    return response.data;
  },

  async getProject(id: string): Promise<Project> {
    const response = await api.get<Project>(`/projects/${id}`);
    return response.data;
  },

  async createProject(data: ProjectCreate): Promise<Project> {
    const response = await api.post<Project>('/projects/', data);
    return response.data;
  },

  async updateProject(id: string, data: Partial<Project>): Promise<Project> {
    const response = await api.put<Project>(`/projects/${id}`, data);
    return response.data;
  },

  async deleteProject(id: string): Promise<void> {
    await api.delete(`/projects/${id}`);
  },

  // Multi-KB Management (Phase 3)
  async listKnowledgeBases(projectId: string): Promise<unknown[]> {
    const response = await api.get<unknown[]>(`/projects/${projectId}/knowledge-bases`);
    return response.data;
  },

  async addKnowledgeBase(projectId: string, kbId: string, kbName?: string): Promise<Project> {
    const params = kbName ? `?kb_name=${encodeURIComponent(kbName)}` : '';
    const response = await api.post<Project>(`/projects/${projectId}/knowledge-bases/${kbId}${params}`);
    return response.data;
  },

  async removeKnowledgeBase(projectId: string, kbId: string, deleteKb: boolean = false): Promise<Project> {
    const response = await api.delete<Project>(`/projects/${projectId}/knowledge-bases/${kbId}?delete_kb=${deleteKb}`);
    return response.data;
  },
};
